<template>
	<CSidebar
		:show="show"
		:minimize="minimize"
		dropdown-mode="closeInactive"
		unfoldable
	>
		<CSidebarBrand class="d-md-down-none main-logo" to="/">
			<TheLogo type="full" />
			<TheLogo />
		</CSidebarBrand>
		<CRenderFunction
			:content-to-render="navigations"
			flat
		/>
	</CSidebar>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { getMenus } from '../helpers/sidebar';
import navigations from './_nav';

export default {
	name: 'TheSidebar',

	computed: {
		...mapState('sidebar', {
			show: 'sidebarShow',
			minimize: 'sidebarMinimize',
		}),
		...mapGetters('me', {
			userRole: 'role',
		}),
		navigations() {
			const { userRole } = this;

			return [{
				_name: 'CSidebarNav',
				_children: getMenus(navigations, userRole),
			}];
		},
	},
};
</script>
<style lang="scss" scoped>
.main-logo {
	background-color: $color-white;
}
</style>

